import React from 'react'
import NumberConversion from 'Utils/NumberConversion'
import moment from 'moment-mini'
import LoaderWrapper from 'Common/LoaderWrapper/LoaderWrapper';

const PatientPaymentsOverview = ({ patientAccountInfo, loader, extraClass="" }) => {
    const { patientBalance, patientCredit, paidAmount, lastPaymentDate } = patientAccountInfo;
    return (
        <div className="mb-4 bg-white border border-gray-200 rounded-lg ">
            <div className={`px-6 py-4 ${extraClass} `}>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <div>
                        <div className="flex items-center">
                            <h3 className="text-sm font-medium text-gray-500">Balance</h3>
                        </div>
                        <LoaderWrapper loading={loader} className={"w-full h-[57px]"}>
                            <p className="mt-2 text-2xl font-semibold text-gray-900">
                                {NumberConversion(patientBalance)}
                            </p>
                            <p className="mt-1 text-sm text-gray-500">
                                {patientBalance > 0 ? "Outstanding balance due" : "Your account is current"}
                            </p>
                        </LoaderWrapper>
                    </div>
                    <div className="border-gray-200 md:border-l md:border-r md:px-6">
                        <h3 className="text-sm font-medium text-gray-500">Available Credit</h3>
                        <LoaderWrapper loading={loader} className={"w-full h-[57px]"}>
                            <p className="mt-2 text-2xl font-semibold text-gray-900">
                                {NumberConversion(patientCredit)}
                            </p>
                            <p className="mt-1 text-sm text-gray-500">
                                Available credit on your account
                            </p>
                        </LoaderWrapper>
                    </div>
                    <div>
                        <h3 className="text-sm font-medium text-gray-500">Last Payment</h3>
                        <LoaderWrapper loading={loader} className={"w-full h-[57px]"}>
                            <p className="mt-2 text-2xl font-semibold text-gray-900">
                                {NumberConversion(paidAmount)}
                            </p>
                            <p className="mt-1 text-sm text-gray-500">
                                {(() => {
                                    const m = moment(`${lastPaymentDate}`);
                                    return m.isValid() ? m.format('MM/DD/YYYY') : '';
                                })()}
                            </p>
                        </LoaderWrapper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientPaymentsOverview